import React from 'react';
import moment from 'moment'
import {inject} from 'mobx-react';
import {Link, withRouter} from 'react-router-dom';
import Truncate from 'react-truncate'
import HttpClient from 'services/HttpClient';
import MapMarker from 'styles/img/location.svg';

@inject('user')
@withRouter
export default class MyRegularWorkshopsCard extends React.Component {

  constructor(props) {
    super(props)
  }

  redirectTo = () => {
    const { workshop } = this.props;
    this.props.redirectToAttendees(workshop.id);
  }
  handleFixToTop = workshop =>{
    const workshop_id = workshop.id;
    const {is_fixed} = workshop;
    const formData = new FormData();
    formData.append("workshop_id", workshop_id);
    formData.append("is_fixed", !is_fixed)
    new HttpClient()
          .multipart("/api/v1/workshops/change_fixed_status", formData, "POST")
          .then(data => {
            console.log(data);
            if (data.status == '200'){
              window.location.reload()
            }
          })
  }

  handleDelete = () => {
    this.props.handleDelete(this.props.workshop.id)
  };

  redirect = () => {

  };

  render() {
    const { workshop } = this.props;
    let user = this.props.user.getUser();
    return (
      <div className="provider-card-wrapper col-12 col-md-6 col-lg-4">
        <div className="provider-card card">
          <div className="top-row">
            <span className="ws-date">{moment(workshop.start_date).format("DD MMM 'YY")}</span>
            <img
              className="location-icon"
              src={MapMarker}
              alt="loc"
            />
            <span className="ws-location">{workshop.venue_county}</span>
          </div>
          <p className="ws-title">
            <Truncate lines={2} width={250} ellipsis={<span>...</span>}>
              { workshop.title }
            </Truncate>
          </p>
          <span className="btn-outlined" onClick={this.redirectTo} style={{'cursor': 'pointer'}}>attendees</span>
          <Link to={`/createregular/${this.props.workshop.id}`}
            className="btn bordered prime card-btn workshop-item-buttons btn-greeny">
            edit
          </Link>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/providers/MyRegularWorkshopsCard.jsx